import React, { FC } from 'react'

import { clsx } from 'clsx'
import { useController } from 'react-hook-form'

import Lock from 'Icons/lock.svg'

import ErrorMessage from 'Components/ErrorMessage'
import PhoneInput from 'Components/PhoneInput'

import FormErrors from '../../FormErrors'

interface Props {
  disabled?: boolean
  submitting?: boolean
}

const Phone: FC<Props> = ({ disabled, submitting }) => {
  const { field } = useController({
    name: 'phone',
    rules: { required: 'Phone is required' },
  })
  const { locationCountryIsoCodes } = window.VARIABLES
  const defaultCountry = locationCountryIsoCodes[0] || 'US'
  const continueLabel = submitting ? 'Verifying' : 'Continue'

  return (
    <div className="position-relative d-flex flex-column align-items-start mb-2 checkout-contact-flow__field-group">
      <label className="sr-only" htmlFor="customer-phone">
        Please enter your phone number
      </label>
      <div className="checkout-contact-flow__phone-submit-row">
        <PhoneInput
          {...field}
          required
          addInternationalOption={false}
          autoComplete="tel"
          countryOptionsOrder={locationCountryIsoCodes}
          defaultCountry={defaultCountry}
          id="customer-phone"
          numberInputProps={{ className: 'form-control' }}
          placeholder="Enter your phone number"
          readOnly={disabled}
        />
        {disabled ? null : (
          <button
            aria-label={continueLabel}
            className={clsx('btn btn-accent checkout-contact-flow__phone-submit-btn', { btn_loading: submitting })}
            disabled={submitting}
            type="submit"
          >
            {continueLabel}
          </button>
        )}
      </div>
      {disabled ? (
        <span aria-hidden="true" className="checkout-contact-flow__phone-lock">
          <Lock />
        </span>
      ) : null}
      <ErrorMessage as={FormErrors} name="phone" />
    </div>
  )
}

export default Phone
